export const HelpPageIDs = {
  searchInput: 'searchInput',
} as const;
